module.exports = __webpack_public_path__ + "img/Logo_KAST.299b7797.jpg";